import { tokens } from "./styles";

// Segmented control switching the cohort between everyone preparing for the CRE
// and only candidates sitting the same exam. Disabled when the candidate hasn't
// committed to a sitting (nothing meaningful to compare against).
export default function ScopeToggle({ scope, sittingAvailable, sittingLabel, onChange }) {
  const options = [
    { key: "all", label: "All CRE candidates" },
    {
      key: "sitting",
      label: sittingLabel ? `My sitting · ${sittingLabel}` : "My sitting",
      disabled: !sittingAvailable,
    },
  ];

  return (
    <div role="group" aria-label="Cohort scope" style={wrap}>
      {options.map((opt) => {
        const active = scope === opt.key;
        return (
          <button
            key={opt.key}
            type="button"
            disabled={opt.disabled}
            aria-pressed={active}
            onClick={() => !opt.disabled && onChange(opt.key)}
            title={opt.disabled ? "Set your exam sitting in your profile to compare with your cohort." : undefined}
            style={{
              ...btn,
              ...(active ? btnActive : null),
              ...(opt.disabled ? btnDisabled : null),
            }}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}

const wrap = {
  display: "inline-flex",
  border: `1px solid ${tokens.ink200}`,
  borderRadius: "8px",
  overflow: "hidden",
  background: tokens.paper,
};

const btn = {
  appearance: "none",
  border: "none",
  background: "transparent",
  padding: "8px 14px",
  fontSize: "13px",
  fontWeight: 600,
  color: tokens.ink500,
  cursor: "pointer",
  fontFamily: tokens.ui,
};

const btnActive = {
  background: tokens.accent,
  color: "#fff",
};

const btnDisabled = {
  color: tokens.ink300,
  cursor: "not-allowed",
};
